<main id="main" class="list-height volume-issue-main">
	<section id="" class="pt-0 volume-issue-sec" aria-label=""> <!--[style.height.px]="containerHeight"-->
		<div class="container volume-issue-container">
			<div class="row mb-4" *ngIf="themeSettingsData">
				<!-- *ngIf="(volumesAndIssues || showCurrentArticlesOnly || thematicOnly)" -->
				<span class="article-breadcrumb-sec">
					<span (click)="goToPage('')" (keyup.enter)="goToPage('')" (keyup.space)="goToPage('')"
						class="breadcrumb-nav" title=" {{themeSettingsData.banner_heading}}">
						<i><span class="nav-string nav-string-home"> {{themeSettingsData.banner_heading}}</span></i>
						<fa-icon aria-hidden="true" class="angle-icon" [icon]="['fas', 'angle-right']">
						</fa-icon>
					</span>
					<span *ngIf="volumesAndIssues">
						{{'journal_listing.volume_issue'|translate}}
					</span>

				</span>
				<div class="volume-head-title" data-aos="fade-up" *ngIf="!loading">
					<h1 tabindex="0"> {{'journal_listing.volume_issue'|translate}}</h1>
				</div>
				<div class="volume-head-title " data-aos="fade-up" *ngIf="loading">
					<h1 class="skeleton-title w-50">
						&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</h1>
				</div>
			</div>

			<div class="card-wrapper">

				<ng-container *ngIf="loading">
					<div class="volume-card skeleton-card" *ngFor="let i of [1,2,3,4]">
						<div class="skeleton-img shimmer"></div>
						<div class="skeleton-title shimmer"></div>

						<div class="skeleton-issues">
							<div class="skeleton-issue shimmer" *ngFor="let j of [1,2,3,4]"></div>
						</div>

						<div class="skeleton-footer shimmer"></div>
					</div>
				</ng-container>

				<!-- Real Content -->
				<ng-container *ngIf="!loading">
					
					<div class="volume-card" *ngFor="let volume of volumeData">
						<img *ngIf="volume.volume == '14'" src="assets/images/Vol._14_2026.webp" alt="Volume 14">
						<img *ngIf="volume.volume == '13'" src="assets/images/Vol._13_2025.webp" alt="Volume 13">
						<img *ngIf="volume.volume == '12'" src="assets/images/Vol._12_2024.webp" alt="Volume 12">
						<img *ngIf="volume.volume == '11'" src="assets/images/All_prior.webp" alt="Volume 11">

						<div *ngIf="volume.volume != '14' && volume.volume != '13' && volume.volume != '12' && volume.volume != '11' "
							class="default-img">
						</div>

						<div class="volume-title">Volume {{volume.volume}}</div>

						<div class="issues">
							<ng-container *ngFor="let issue of volume.issue_issues">
								<div>
									<a [routerLink]="setRegularIssueLink(volume.volume, issue.issue)">
										{{ changeIssue(issue.issue) }}
									</a>
								</div>
							</ng-container>
						</div>

						<ng-container *ngIf="volume.thematic && !(volume.volume == '11' && volume.supplementary)">
							<div class="card-footer">
								<!-- <a [routerLink]="'/thematic-collections/articles/' + volume.volume"> -->
								<a [routerLink]="'/thematic-collections/' + volume.volume">

									Thematic Collections
								</a>
							</div>
						</ng-container>

						<ng-container *ngIf="volume.supplementary">
							<div class="card-footer">
								<a [routerLink]="'/supplementary-collections/articles/' + volume.volume">
									Supplementary issues
								</a>
							</div>
						</ng-container>

					</div>
				</ng-container>


			</div>





		</div>

	</section>
</main>